import request from '../utils/backend';
import env from '../environment';
import * as actions from '../constants/customerActions';
import * as events from '../constants/eventActions';

const customerActions = {

    loadAll() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForCustomerState());

            request
                .get(env.tashi + '/customers/getAll')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadCustomers({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text);

                    if (data) {
                        dispatch(actions.loadCustomers({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadCustomers({ status: "success", data: [] }));
                    }
                });
        };
    },

    sync() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForCustomerState());

            request
                .post(env.tashi + '/customers/sync')
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.syncCustomers({ status: "failure", data: err }));
                        dispatch(events.pushErrorEvent({ data: "sync companies" }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.syncCustomers({ status: "success" }));
                        dispatch(events.pushSuccessEvent({ data: "sync companies" }));
                    } else {
                        dispatch(actions.syncCustomers({ status: "failure", data: res.status }));
                        dispatch(events.pushErrorEvent({ data: "sync companies" }));
                    }
                });
        };
    }

};

export default customerActions;



/** WEBPACK FOOTER **
 ** ./src/app/actions/customerActionCreators.js
 **/